// Sub-path segments under an event's base path. Both EventRouter and TempleRouter route these.
export const EVENT_SEGMENTS = {
  addToTree: 'addtotree',
  friend: 'friend',
  join: 'join',
  // Legacy path. LegacyMapRedirect sends it to relatives.
  map: 'map',
  optOut: 'optout',
  relatives: 'relatives',
  settings: 'settings',
} as const
